import { ConfigurationGateway } from './configuration-gateway.interface';

export const initConfigurationAPI = (
  apiSlice: any,
  gateway: ConfigurationGateway
) => {
  apiSlice
    .enhanceEndpoints({
      addTagTypes: ['Configuration', 'Project'],
    })
    .injectEndpoints({
      endpoints: (builder: any) => ({
        getConfigurationsByProject: builder.query({
          query: gateway.getConfigurationsByProject,
          providesTags: ['Configuration', 'Project'],
        }),
        patchConfigurations: builder.mutation({
          query: gateway.patchConfigurations,
          invalidatesTags: ['Configuration', 'Project'],
        }),
        getConfigurationDifference: builder.mutation({
          query: gateway.getConfigurationDifference,
        }),
        getConfigurationFormatToDoc: builder.mutation({
          query: gateway.getConfigurationFormatToDoc,
          // invalidatesTags: ['Configuration'],
        }),
        // generateQuoteDocumentAndGetFile: builder.query({
        //   query: ({
        //     projectId,
        //     configurations,
        //   }: {
        //     projectId: string;
        //     configurations: any;
        //   }) =>
        //     gateway.generateQuoteDocumentAndGetFile(projectId, configurations),
        //   invalidatesTags: ['Configuration'],
        // }),
        getTempConfigurationsPrice: builder.query({
          query: gateway.getTempConfigurationsPrice,
          // invalidatesTags: ['Configuration'],
        }),
        // getQuoteFileFromMainConfig: builder.query({
        //   query: (projectId: string) =>
        //     gateway.getQuoteFileFromMainConfig(projectId),
        //   invalidatesTags: ['Configuration'],
        // }),
      }),
      overrideExisting: false,
    });
};

export interface ConfigurationSliceType {
  useGetConfigurationsByProjectQuery: Function;
  usePatchConfigurationsMutation: Function;
  useGetConfigurationDifferenceMutation: Function;
  useGetConfigurationFormatToDocMutation: Function;
  useGetTempConfigurationsPriceQuery: Function;
  useLazyGetTempConfigurationsPriceQuery: Function;
}
